import { render } from "./TabMaterialLibrary.vue?vue&type=template&id=bbe1f68a&scoped=true"
import script from "./TabMaterialLibrary.vue?vue&type=script&lang=js"
export * from "./TabMaterialLibrary.vue?vue&type=script&lang=js"

import "./TabMaterialLibrary.vue?vue&type=style&index=0&id=bbe1f68a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbe1f68a"]])

export default __exports__